module.exports = __webpack_public_path__ + "img/wall-lamp.9a16c3fd.svg";